import React from 'react'
import dynamic from 'next/dynamic'
import Success from './json/success'
import Spinner from './json/spinner'
import Warning from './json/warning'

// Load browser-only animation code on the client.
const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

const defaultOptions = (animationData) => ({
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
})

function Animation({ name, width = 400, height = 400, ...options }) {
  const animationData = animations[name] || null
  return (
    <div className="pointer-events-none">
      <Lottie options={{ ...defaultOptions(animationData), ...options }} width={width} height={height} />
    </div>
  )
}

const animations = {
  success: Success,
  spinner: Spinner,
  warning: Warning,
}

export default Animation
